import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { useSiteContent } from '../../context/SiteContentContext';
import './WhyChooseHKI.css';

const DEFAULT_TITLE = 'Why Industries Choose HKI for ';
const DEFAULT_HIGHLIGHT = 'Superior Performance';
const DEFAULT_INTRO = 'We deliver solutions that maximize efficiency, minimize downtime, and ensure seamless operations in even the most demanding environments. Industries choose HKI for our unmatched quality, innovative engineering, and reliable performance.';
const DEFAULT_ITEMS = [
  { title: 'Authorized Supplier', description: 'Providing genuine industrial valves, fittings, and instrumentation for trusted performance.' },
  { title: 'Expert Guidance', description: 'Helping you find the perfect solutions for your operational requirements.' },
  { title: 'Reliable Support', description: 'Assisting you from selection to after-sales service.' },
];

const WhyChooseHKI = () => {
  const { siteContent } = useSiteContent();

  const title = siteContent?.why_choose_title ?? DEFAULT_TITLE;
  const highlight = siteContent?.why_choose_highlight ?? DEFAULT_HIGHLIGHT;
  const intro = siteContent?.why_choose_intro ?? DEFAULT_INTRO;
  const items =
    Array.isArray(siteContent?.why_choose_items) && siteContent.why_choose_items.length > 0
      ? siteContent.why_choose_items
      : DEFAULT_ITEMS;
  const needsTitleHighlightSpace = Boolean(highlight) && title !== '' && !/\s$/.test(title);

  return (
    <section className="why-choose-hki">
      <div className="why-choose-container">
        <h2 className="why-choose-title">
          {title}
          {needsTitleHighlightSpace ? ' ' : ''}
          {highlight && <span className="highlight">{highlight}</span>}
          {title.trim().endsWith('?') ? '' : '?'}
        </h2>
        {intro && <p className="why-choose-intro">{intro}</p>}
        <div className="why-choose-cards">
          {items.map((benefit, index) => (
            <div key={index} className="why-choose-card">
              <div className="card-check">
                <FaCheck />
              </div>
              <h3 className="card-title">{benefit.title || ' '}</h3>
              <p className="card-description">{benefit.description || ' '}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseHKI;
